import React from 'react';
import {
  Layout,
  Image as ImageIcon,
  Type,
  List,
  MousePointerClick,
  Link2,
  Minus,
  Space,
  FileCode,
  Layers,
  Music,
  Video
} from 'lucide-react';
import './BlockPaletteNew.css';

const BLOCK_TYPES = [
  { type: 'header', label: 'Header', Icon: Layout, description: 'Logo and navigation' },
  { type: 'hero', label: 'Hero', Icon: ImageIcon, description: 'Large image with headline' },
  { type: 'image', label: 'Image', Icon: ImageIcon, description: 'Single image from library' },
  { type: 'content', label: 'Content', Icon: Type, description: 'Rich text body' },
  { type: 'tracklist', label: 'Tracklist', Icon: List, description: 'Music track list' },
  { type: 'music-player', label: 'Music Player', Icon: Music, description: 'Audio player with tracks' },
  { type: 'video', label: 'Video', Icon: Video, description: 'YouTube video embed' },
  { type: 'cta', label: 'Call to Action', Icon: MousePointerClick, description: 'Button with link' },
  { type: 'social', label: 'Social Links', Icon: Link2, description: 'Social media icons' },
  { type: 'footer', label: 'Footer', Icon: Layout, description: 'Footer with unsubscribe' },
  { type: 'custom', label: 'Custom HTML', Icon: FileCode, description: 'Custom HTML code' },
  { type: 'spacer', label: 'Spacer', Icon: Space, description: 'Vertical spacing' },
  { type: 'divider', label: 'Divider', Icon: Minus, description: 'Horizontal line' },
];

const BlockPaletteNew = ({ onAddBlock }) => {
  const handleAddBlock = (blockType) => {
    // Just pass the blockType string - EditorPage will create the block
    onAddBlock(blockType);
  };

  return (
    <div className="block-palette-new">
      <div className="palette-header">
        <Layers size={18} strokeWidth={2} />
        <h3>Add Blocks</h3>
      </div>
      <p className="palette-subtitle">Drag or click to add</p>

      <div className="palette-grid">
        {BLOCK_TYPES.map(({ type, label, Icon, description }) => (
          <button
            key={type}
            className="palette-block-btn"
            onClick={() => handleAddBlock(type)}
            title={description}
          >
            <div className="palette-block-icon">
              <Icon size={20} strokeWidth={2} />
            </div>
            <span className="palette-block-label">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BlockPaletteNew;
